'use strict';

let $priceInputGroup = null;
let $minPriceInput = null;
let $maxPriceInput = null;
let $priceSlider = null;
let $priceButton  =null;
let totalRangeMin = null;
let totalRangeMax = null;
let searchRangeMin = null;
let searchRangeMax = null;
let sliderInstance = null;

let parseResults = null;
const ENTER_KEY = 13;

const searchFilter = require('./searchFilter');
const debounce = require('../util/debounce');
/**
 * Returns the refinement URL aplying pmin and max values for price search
 *
 * @param {string} url - Search url
 * @param {string} min - Slider left tuner value
 * @param {string} max - Slider right tuner value
 * @return {string} url
 */
function applyMinMaxPriceToUrl(url, min, max) {
    if(!url || !url.length) {
        return null;
    }

    const [baseUrl, params] = url.split('?');

    if(!params) {
        return url;
    }

    const pmin = 'pmin=' + parseFloat(min);
    const pmax = 'pmax=' + parseFloat(max);
    let pminxExists = false;
    let pmaxExists = false;

    let newParams = params.split('&').map((param) => {
        if(param.includes('pmin')) {
            pminxExists = true;
            return pmin;
        }

        if (param.includes('pmax')) {
            pmaxExists = true;
            return pmax;
        }
        return param;
    });

    if(!pminxExists) {
        newParams.push(pmin);
    }

    if(!pmaxExists) {
        newParams.push(pmax);
    }

    return `${baseUrl}?${newParams.join('&')}`;
}

/**
 * Triggered when user interacts with slider
 *
 * @param {*} event - Slider event
 * @param {Object} slider - Current slider state
 */
function handleSlide(event, slider) {
    $minPriceInput.val(slider.values[0]);
    $maxPriceInput.val(slider.values[1]);
    debounce(filterByPrice, 500)(slider.values[0], slider.values[1]);
}

/**
 * Performs the price search
 * @param {string} min - Slider left tuner value
 * @param {string} max - Slider right tuner value
 */
function filterByPrice (min, max) {
    const url = applyMinMaxPriceToUrl($priceSlider.data('href'), min, max);
    const seoUrl = applyMinMaxPriceToUrl($priceSlider.data('seo-href'), min, max);

    $priceButton.attr('data-href', url);
    $priceButton.attr('data-seo-href', seoUrl);
    $priceButton.trigger('click');
}

/**
 * Create the slider instance
 */
function instancePriceSlider() {
    try {
        sliderInstance = $priceSlider.slider({
            range: true,
            min: totalRangeMin,
            max: totalRangeMax,
            values: [ searchRangeMin, searchRangeMax ],
            step: 0.01,
            slide: handleSlide
        });
    }
    catch(err) {
        console.error(err);
    }
}

/**
 * Keyup handler
 * @param {*} e - Event
 */
function handleKeyupMinPrice(e) {
    //Perform actions only on enter key pressed
    if(e.keyCode !== ENTER_KEY) {
        return;
    }

    const $this = $(this);
    const newValue = parseFloat($this.val());
    searchRangeMax = parseFloat($maxPriceInput.val());

    if(newValue >= totalRangeMin && newValue < searchRangeMax) {
        sliderInstance.slider('values', 0, newValue);
        filterByPrice(newValue, searchRangeMax);
    } else if (newValue < totalRangeMin) {
        sliderInstance.slider('values', 0, totalRangeMin);
        $this.val(totalRangeMin.toFixed(2));
    } else { // newValue >= searchRangeMax:
        const clampedValue = parseFloat((searchRangeMax - 0.1).toFixed(2));
        sliderInstance.slider('values', 0, clampedValue);
        $this.val(clampedValue.toFixed(2));

    }
}

/**
 * Keyup handler
 * @param {*} e - Event
 */
function handleKeyupMaxPrice(e) {
    //Perform actions only on enter key pressed
    if(e.keyCode !== ENTER_KEY) {
        return;
    }

    const $this = $(this);
    const newValue = parseFloat($this.val());
    searchRangeMin = parseFloat($minPriceInput.val());

    if(newValue <= totalRangeMax && newValue > searchRangeMin) {
        sliderInstance.slider('values', 1, newValue);
        filterByPrice(searchRangeMin, newValue);
    } else if (newValue > totalRangeMax) {
        sliderInstance.slider('values', 1, totalRangeMax);
        $this.val(totalRangeMax.toFixed(2));
    } else { // newValue <= searchRangeMin
        const clampedValue = parseFloat((searchRangeMin + 0.1).toFixed(2));
        sliderInstance.slider('values', 1, clampedValue);
        $this.val(clampedValue.toFixed(2));
    }
}

/**
 * On click handler, triggered programmatically
 * @param {*} e - click event
 */
function handleRefinementPriceButtonClick(e) {
    searchFilter.send(e, $(this), parseResults);
}

module.exports = {
    initSlider: function(parseResultsFn) {
        parseResults = parseResultsFn;

        //Capture elements
        $priceSlider = $('.search-refinements-container:visible .price-slider').first();
        $minPriceInput = $('.price-values .min-price').first();
        $maxPriceInput = $('.price-values .max-price').first();
        $priceButton = $('.refinement-price-button').first();
        $priceInputGroup = $('.price-values .price-input-group').first();

        if($priceInputGroup.length) {
            totalRangeMin = Number($priceInputGroup.data('min-price'));
            totalRangeMax = Number($priceInputGroup.data('max-price'));
            searchRangeMin = Number($priceInputGroup.data('selected-price-min'));
            searchRangeMax = Number($priceInputGroup.data('selected-price-max'));

            instancePriceSlider();
        }

        //Set events
        $minPriceInput.on('keyup', handleKeyupMinPrice);
        $maxPriceInput.on('keyup', handleKeyupMaxPrice);
        $priceButton.on('click', handleRefinementPriceButtonClick);
    },
}
